<template>
  <div>
    <select class="c-select" required v-model="selectedId" @change="$emit('update:modelValue', selectedId)">
      <option value=""></option>
      <option v-for="klasNode in nodes" :key="klasNode.value.id" :value="klasNode.value.id">
        {{ klasNode.value.title }}
      </option>
    </select>
    <KlasTree v-if="selected?.children?.length" :nodes="selected.children" :selectedIds="selectedIds" @update:modelValue="$emit('update:modelValue', $event)" />
  </div>
</template>

<script>
import { ref, computed, watchEffect } from "vue";

export default {
  emits: ["update:modelValue"],
  props: {
    nodes: { type: Array, required: true },
    modelValue: { type: String, required: false },
    selectedIds: { type: Array, required: false },
  },
  name: "KlasTree",
  setup(props) {
    const selectedId = ref();
    const selected = computed(() => props.nodes.find((n) => n.value.id == selectedId.value));

    watchEffect(() => {
      if (props.selectedIds?.length) {
        selectedId.value = props.nodes.find((n) => props.selectedIds.some((id) => id == n.value.id))?.value?.id;
      }
    });

    return {
      selectedId,
      selected,
    };
  },
};
</script>
